import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'modeDi';
const args = {};

export class ModeDi extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
